"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var OptionsMenu =
/*#__PURE__*/
function (_Component) {
  _inherits(OptionsMenu, _Component);

  function OptionsMenu() {
    var _this;

    _classCallCheck(this, OptionsMenu);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(OptionsMenu).call(this));
    _this.itemRefs = [];
    _this.state = {
      itemIndex: 0
    };
    _this.onKeyDown = _this.onKeyDown.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(OptionsMenu, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var itemIndex = this.state.itemIndex;
      var show = this.props.show;

      if (!prevProps.show && show && this.itemRefs.length) {
        // handles opens
        this.itemRefs[0].focus();
      } else if (prevState.itemIndex !== itemIndex) {
        // handle up/down arrows
        this.itemRefs[itemIndex].focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          id = _this$props.id,
          show = _this$props.show,
          other = _objectWithoutProperties(_this$props, ["children", "id", "show"]);

      var items = children.map(function (_ref, i) {
        var props = _ref.props;
        return _react["default"].createElement("li", _extends({
          key: "".concat(id, "-").concat(i),
          className: "dqpl-options-menuitem",
          tabIndex: -1,
          role: "menuitem",
          ref: function ref(el) {
            return _this2.itemRefs[i] = el;
          }
        }, props));
      });
      return _react["default"].createElement("ul", _extends({}, other, {
        className: "dqpl-options-menu",
        "aria-expanded": show,
        id: id,
        role: "menu",
        onKeyDown: this.onKeyDown
      }), items);
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(e) {
      var which = e.which,
          target = e.target;

      switch (which) {
        // up / down
        case 38:
        case 40:
          {
            var itemIndex = this.state.itemIndex;
            var itemCount = this.itemRefs.length;
            var newIndex = which === 38 ? itemIndex - 1 : itemIndex + 1; // circularity

            if (newIndex === -1) {
              newIndex = itemCount - 1;
            } else if (newIndex === itemCount) {
              newIndex = 0;
            }

            e.preventDefault();
            this.setState({
              itemIndex: newIndex
            });
            break;
          }
        // escape

        case 27:
          this.props.onClose();
          break;
        // enter / space

        case 13:
        case 32:
          e.preventDefault();
          target.click();
          break;
        // tab

        case 9:
          e.preventDefault();
          this.props.onClose();
      }
    }
  }]);

  return OptionsMenu;
}(_react.Component);

exports["default"] = OptionsMenu;

_defineProperty(OptionsMenu, "propTypes", {
  children: _propTypes["default"].node.isRequired,
  id: _propTypes["default"].string.isRequired,
  onClose: _propTypes["default"].func.isRequired,
  show: _propTypes["default"].bool
});

_defineProperty(OptionsMenu, "defaultProps", {
  show: false
});